//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getGroupStatus } from '@/api/pintuan'
import config from '@/config/index'
import { operateCreditlist } from '@/api/user.js'
export default {
  data () {
    return {
      baseUrl: config.baseUrl,
      owner_type: config.owner_type,
      groupid: this.$route.params.groupid,
      shareaccountid: this.$route.params.shareid,
      obj: {},
      countDownCont: '',
      status: null
    }
  },
  computed: {
    accountid () {
      return this.$store.state.user.accountid
    }
  },
  mounted () {
    this.getDetail()
    this.addIntegral()
  },
  methods: {
    // 首次通过分享进入加积分
    addIntegral () {
      operateCreditlist({
        accountid: this.accountid,
        rulecode: 'rule_001',
        credit: 10,
        owner_type: this.owner_type,
        relationtype: 2,
        relationid: 1,
        terminaltype: 2
      }).then(res => {})
    },
    getDetail () {
      getGroupStatus({
        groupid: this.groupid,
        accountid: this.accountid,
        shareaccountid: this.shareaccountid
      }).then(res => {
        this.obj = res.returnValue
        this.countDown(this.obj.startdate, this.obj.enddate)
        if (this.obj.addCredit > 0) {
          this.$vux.toast.text('+ ' + this.obj.addCredit + ' 积分')
        }
      })
    },
    countDown (startDate, endDate) {
      let curDate = new Date()
      startDate = new Date(startDate.replace(/-/g, '/'))
      endDate = new Date(endDate.replace(/-/g, '/'))
      let t1 = (startDate.getTime() - curDate.getTime()) / 1000
      if (t1 > 0) {
        this.countDownCont = '未开始'
        this.status = 0
        return false
      }
      let t = (endDate.getTime() - curDate.getTime()) / 1000
      if (t > 0) {
        this.status = 1
      } else {
        this.status = 2
      }
      let timer = setInterval(() => {
        if (t > 0) {
          let hour = Math.floor(t / (60 * 60))
          let minute = Math.floor(t / 60) - hour * 60
          let second = Math.floor(t) - hour * 60 * 60 - minute * 60
          hour = hour < 10 ? '0' + hour : hour.toString()
          minute = minute < 10 ? '0' + minute : minute.toString()
          second = second < 10 ? '0' + second : second.toString()
          this.countDownCont = ''
          hour.split('').forEach(item => {
            this.countDownCont += `<span>${item}</span>`
          })
          this.countDownCont += '<i>:</i>'
          minute.split('').forEach(item => {
            this.countDownCont += `<span>${item}</span>`
          })
          this.countDownCont += '<i>:</i>'
          second.split('').forEach(item => {
            this.countDownCont += `<span>${item}</span>`
          })
        } else {
          clearInterval(timer)
          this.countDownCont = '已结束'
          this.status = 2
        }
        t--
      }, 1000)
    },
    goProductDetail () {
      this.$router.push({
        name: 'pintuanDetail',
        params: {
          id: this.obj.productid
        }
      })
    }
  }
}
